import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@flashtalking/rhombus-react';

import { downloadAssets } from 'reducers/Assets';
import { buildSelectedAssetsToDownload } from 'selectors/Assets';
import { ASSET_TYPES } from 'utils/constants';
import { DownloadAssets } from 'widgets/messages/DownloadAssets';
import useNotifier from 'hooks/useNotifier';

export const createAssetFileName = (libraryId, assetsIds, initialFileName, assetType) => {
	let fileName;
	let fileNameAssetType = assetType === ASSET_TYPES.AUDIO ? assetType : `${assetType}s`;

	if(assetsIds.size === 1) {
		fileName = initialFileName;
	} else {
		fileName = `CreativeLibrary-${libraryId}-${assetsIds.size}-${fileNameAssetType}.zip`;
	}
	return fileName;
};

export default function BulkDownloadAssets(props){
	const { libraryId, libraryName } = props
		, dispatch = useDispatch()
		, notifier = useNotifier()
		, { initialFileNames, assetSets, hasEligibleAssets } = useSelector(buildSelectedAssetsToDownload)
		, { richloadFileName, imageFileName, videoFileName, audioFileName } = initialFileNames || {}
		, { richloadAssets, imageAssets, videoAssets, audioAssets } = assetSets || {};

	function notifyDispatchDownload(assetArray, assetType, fileName) {
		const DOWNLOAD_TOPIC = "Download Assets";
		const message = {
			origin: "HOPI",
			task: "Download Started",
			status: "In Progress",
			data: {
				fileName,
				libraryName,
				assetType,
			},
			component: DownloadAssets,
		};

		notifier(
			dispatch(downloadAssets(libraryId, assetArray, assetType.toLowerCase(), fileName)),
			DOWNLOAD_TOPIC,
			message
		);
	}

	const handleClick = () => {
		if(richloadAssets?.size) {
			const parsedFileName = `${richloadFileName.replace('/index.html', '')}.zip`;
			let zip = (richloadAssets.size === 1) ? parsedFileName : `CreativeLibrary-${libraryId}-${parsedFileName}`;

			let fileName = createAssetFileName(libraryId, richloadAssets, zip, 'Richload');
			notifyDispatchDownload([...richloadAssets], ASSET_TYPES.RICHLOAD, fileName);
		}
		if(videoAssets?.size) {
			let fileName = createAssetFileName(libraryId, videoAssets, videoFileName, 'Video');
			notifyDispatchDownload([...videoAssets], ASSET_TYPES.VIDEO, fileName);
		}
		if(imageAssets?.size) {
			let fileName = createAssetFileName(libraryId, imageAssets, imageFileName, 'Image');
			notifyDispatchDownload([...imageAssets], ASSET_TYPES.IMAGE, fileName);
		}
		if(audioAssets?.size) {
			let fileName = createAssetFileName(libraryId, audioAssets, audioFileName, 'Audio');
			notifyDispatchDownload([...audioAssets], ASSET_TYPES.AUDIO, fileName);
		}
	};

	if(!hasEligibleAssets) {
		return false;
	}

	return (
		<Button
			style="block"
			icon="fas fa-cloud-download"
			theme="blue"
			onClick={handleClick}
			className="download-assets"
		>Download</Button>
	);
}


BulkDownloadAssets.displayName = "BulkDownloadAssets";
